<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row :gutters="15">
      <el-col :sm="12">
        <h4 class="form-title">Stock-Out Report</h4>
      </el-col>
      <el-col :sm="12">
        <div class="text-right">
          <!-- <el-select
            v-model="pager.jo_id"
            placeholder="Select job order here"
            filterable
            @change="fetchReport"
            clearable
          >
            <el-option
              v-for="jo in stockouts"
              :key="jo.id"
              :label="jo.job_order_no"
              :value="jo.id"
            ></el-option>
          </el-select>
          <el-button class="ml-1" type="primary" size="small" @click="download"
            >Download Report</el-button
          > -->
          <el-button type="primary" size="small" @click="dialogView = true">
            Filter <span class="el-icon-search"></span>
          </el-button>
          <el-button class="ml-1" type="primary" size="small" @click="download"
            >Download Report</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-dialog ref="dialog" :visible.sync="dialogView" title="Report Filter">
      <el-form label-position="left" label-width="120px">
        <el-form-item label="Job Order">
          <el-select
            v-model="pager.jo_id"
            placeholder="Select job order here"
            clearable
            filterable
          >
            <el-option
              v-for="jo in stockouts"
              :key="jo.id"
              :label="jo.job_order_no"
              :value="jo.job_order_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Supplier">
          <el-select
            v-model="pager.supplier_id"
            placeholder="Select supplier information here"
            clearable
            filterable
          >
            <el-option
              v-for="item in suppliers"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Part">
          <el-select
            v-model="pager.part_id"
            placeholder="Select part information here"
            clearable
            filterable
          >
            <el-option
              v-for="item in parts"
              :key="item.id"
              :label="item.part_no"
              :value="item.part_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Date Range">
          <el-date-picker
            v-model="pager.date_range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="fetchReport(1)">Search</el-button>
      </el-form>
    </el-dialog>
    <el-table :data="list.data">
      <el-table-column label="Job Order No." prop="order_no"></el-table-column>
      <el-table-column label="Batch No." prop="batch_no"></el-table-column>
      <el-table-column label="Supplier" prop="supplier_name"></el-table-column>
      <el-table-column label="Part No." prop="part_no"></el-table-column>
      <el-table-column label="Description" prop="description"></el-table-column>
      <el-table-column label="Location" prop="location"></el-table-column>
      <el-table-column label="Quantity Issued" prop="quantity">
        <template slot-scope="scope">{{
          scope.row.quantity | number("0,0")
        }}</template>
      </el-table-column>
      <el-table-column label="Date Issued" prop="date_issued">
        <template slot-scope="scope">
          <span>{{ scope.row.date_issued | dateFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Final Price (AED)" prop="final_price_aed">
        <template slot-scope="scope">
          <span>{{ scope.row.final_price_aed | currency("AED ") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Final Price (USD)" prop="final_price_usd">
        <template slot-scope="scope">
          <span>{{ scope.row.final_price_usd | currency("$ ") }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-row :gutters="15" type="flex" align="middle">
      <el-col :sm="12">
        <el-pagination
          v-show="!isLoading"
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="fetchReport"
        ></el-pagination>
      </el-col>
      <el-col :sm="12" class="text-right">
        <el-button type="primary" size="small" @click="download"
          >Download Report</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
import Part from "@/models/Part";
import Supplier from "@/models/Supplier";
export default {
  name: "StockoutReport",

  data() {
    return {
      isLoading: false,
      list: { data: [], paging: {} },
      stockouts: {},
      pager: {
        page: 1,
        limit: 25,
        search: "",
        jo_id: "",
        supplier_id: "",
        part_id: "",
        date_range: ""
      },
      dialogView: false,
      parts: [],
      suppliers: []
    };
  },
  computed: {
    report_url() {
      var uri = `${api.baseUrl}api/v1/stockout/history_download/?jo_name=${this.pager.jo_id}&supplier=${this.pager.supplier_id}&part_name=${this.pager.part_id}`;
      // if (this.pager.jo_id) return `${uri}?jo_id=${this.pager.jo_id}`;
      if (this.pager.date_range && this.pager.date_range.length > 1) {
        let date_from = moment(this.pager.date_range[0]);
        let date_to = moment(this.pager.date_range[1]);
        uri = `${uri}&date_from=${date_from.format(
          "YYYY-MM-DD"
        )}&date_to=${date_to.format("YYYY-MM-DD")}`;
      }
      return uri;
    }
  },
  mounted() {
    this.fetchJO();
    this.fetchReport();
    Part.getGlossary().then(list => {
      this.parts = list;
    });
    Supplier.getGlossary().then(list => {
      this.suppliers = list;
    });
  },
  methods: {
    fetchJO() {
      api.get(`/api/v1/stockout/jo_list/`).then(resp => {
        if (resp && resp.status == 200) {
          this.stockouts = resp.data.data;
        }
      });
    },
    fetchReport(page) {
      // if (this.pager.jo_id) {
      // var uri = `/api/v1/stockout/history/?jo_name=${this.pager.jo_id}&supplier=${this.pager.supplier_id}&part_name=${this.pager.part_id}`;
      // if (this.pager.jo_id) uri = `${uri}?jo_id=${this.pager.jo_id}`;
      // if (this.pager.date_range && this.pager.date_range.length > 1) {
      //   let date_from = moment(this.pager.date_range[0]);
      //   let date_to = moment(this.pager.date_range[1]);
      //   uri = `${uri}&date_from=${date_from.format(
      //     "YYYY-MM-DD"
      //   )}&date_to=${date_to.format("YYYY-MM-DD")}`;
      // }
      var uri = `/api/v1/stockout/history/`;
      let params = {
        limit: this.pager.limit,
        page: page ? page : this.pager.page,
        jo_name: this.pager.jo_id,
        supplier: this.pager.supplier_id,
        part_name: this.pager.part_id
      };
      if (this.pager.date_range && this.pager.date_range.length > 1) {
        let date_from = moment(this.pager.date_range[0]);
        let date_to = moment(this.pager.date_range[1]);
        params.date_from = date_from.format("YYYY-MM-DD");
        params.date_to = date_to.format("YYYY-MM-DD");
      }

      this.isLoading = true;
      api.get(uri, params).then(resp => {
        if (resp && resp.status == 200) {
          this.list = resp.data;
        }
        this.isLoading = false;
      });
      this.dialogView = false;
      // }
    },
    download() {
      var d = moment().format("MM-DD-YYYY");
      var reportInfo = {
        name: `Stock-Out Report ${d}`,
        ext: ".csv"
      };
      this.isLoading = true;
      api.download(this.report_url, reportInfo).then(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
